import LabelsGrid from './labels-grid';

export default function LabelsPage() {
  return <LabelsGrid />;
}
